export default __webpack_public_path__ + "static/media/SuperShadows_05.de0dce39.png";